import { ELSRestClientHelper } from '@els/els-ui-common-react';
import { ServerConstants } from '../../components/app/server.constants';
import {
  PastedSyllabusAnalysisRequest,
  SyllabusAnalysisResponse
} from './enhanced-course-builder-service.dtos';
import {
  getDefaultRequestOptions,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';

const AI_SERVICE_PATH = '/cw-ai/syllabus/preview';

const getAiServiceBaseUrl = () => {
  const envConfig = ServerConstants[ServerConstants.DataSource];
  return envConfig?.aiServiceBaseURL;
};

const postSyllabusAnalysisForm = (formData: FormData): Promise<SyllabusAnalysisResponse> => {
  const baseUrl = getAiServiceBaseUrl();

  if (!baseUrl) {
    return Promise.reject(new Error('aiServiceBaseURL not found'));
  }

  return withApiErrorLoggingOnly(() => {
    // ELSRestClientHelper defaults to a JSON Content-Type, and axios 1.x then serializes FormData
    // to JSON. Declare multipart so the body stays FormData (the browser adds the boundary).
    return ELSRestClientHelper.post(
      `${baseUrl}${AI_SERVICE_PATH}`,
      getDefaultRequestOptions({
        data: formData,
        timeout: 360000
      }, { 'Content-Type': 'multipart/form-data' })
    );
  });
};

export const analyzeSyllabus = async (
  file: File,
  courseSectionId: string,
  llmProvider = 'claude'
): Promise<SyllabusAnalysisResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('courseSectionId', courseSectionId);
  formData.append('llm_provider', llmProvider);

  return postSyllabusAnalysisForm(formData);
};

export const analyzePastedSyllabus = async (
  pastedSyllabus: PastedSyllabusAnalysisRequest,
  courseSectionId: string
): Promise<SyllabusAnalysisResponse> => {
  const formData = new FormData();
  formData.append('syllabusHtml', pastedSyllabus.syllabusHtml);
  formData.append('courseSectionId', courseSectionId);

  return postSyllabusAnalysisForm(formData);
};
